import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { LocalStorageService } from '../local-storage/local-storage.service';
import { LoginService } from '../auth/login/login.service';
import { ErrorReportingService } from '../error-reporting/error-reporting.service';

@Injectable()
export class HttpInterceptService implements HttpInterceptor {

  constructor(
    private loginService: LoginService,
    private localStorageService: LocalStorageService,
    private errorReportingService: ErrorReportingService
  ) {}

  intercept(request: HttpRequest <any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addBearer(request)).pipe(
      catchError((response) => {
        if (response && response.status >= 500) {
          this.errorReportingService.handleError(response, request, response);
        }

        if (response instanceof HttpErrorResponse) {
          switch (response.status) {
            case 401:
              return this.handle401Error(request, next);
            case 403:
              return this.handle403Error(request);
          }
        }

        return throwError(response);
      })
    );
  }

  addBearer(request): HttpRequest <any> {
    if (!request.withCredentials) {
      return request;
    }

    let headers;
    const loginObject = this.localStorageService.get('login');

    if (loginObject && loginObject.access_token) {
      headers = request.headers.set('Authorization', 'Bearer ' + loginObject.access);
    }

    return request.clone({ headers: headers });
  }

  handle403Error(request) {
    if(request && request.url.toString().includes("/Auth/Refresh")){
      this.loginService.logOut();
      return of(null);
    }
    return of(null);
  }

  handle401Error(request, next: HttpHandler) {
    const loginObject = this.localStorageService.get('login');
    if (loginObject && loginObject.access_token) {
      return this.loginService.refreshToken(loginObject.refresh).pipe(
        switchMap((data) => {
          this.localStorageService.set('login', data);
          return next.handle(this.addBearer(request));
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
    }
    return throwError('Unauthorized');
  }
}
